export default __webpack_public_path__ + "static/preunic-cl-6de0bae2d5a211a20b5904b813c14679.png";